import { render } from "./ManagePackages.vue?vue&type=template&id=2342b876"
import script from "./ManagePackages.vue?vue&type=script&lang=js"
export * from "./ManagePackages.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__